import React, { memo, SVGProps } from 'react'

export const Archive = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.13537 6.31201H3.70177V16.488C3.70177 17.9434 4.88545 19.128 6.34177 19.128H17.6592C19.1155 19.128 20.2992 17.9434 20.2992 16.488V6.31201H20.8656C21.2631 6.31201 21.5856 5.98945 21.5856 5.59201C21.5856 5.19457 21.2631 4.87201 20.8656 4.87201H3.13537C2.73793 4.87201 2.41537 5.19457 2.41537 5.59201C2.41537 5.98945 2.73793 6.31201 3.13537 6.31201ZM18.8592 6.31201V16.488C18.8592 17.1494 18.3207 17.688 17.6592 17.688H6.34081C5.67937 17.688 5.14081 17.1494 5.14081 16.488V6.31201H18.8592Z"
      fill="currentColor"
    />
    <path
      d="M10.1827 10.153H13.8163C14.2138 10.153 14.5363 9.83041 14.5363 9.43297C14.5363 9.03553 14.2138 8.71297 13.8163 8.71297H10.1827C9.78529 8.71297 9.46273 9.03553 9.46273 9.43297C9.46273 9.83041 9.78529 10.153 10.1827 10.153Z"
      fill="currentColor"
    />
  </svg>
))
